import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { seoConstants as seo } from "src/utils/constants";
import { defaultTag } from "src/utils/constants";

export interface DynamicHelmetProps {
  children: any;
}

export const DynamicHelmet = (props: DynamicHelmetProps) => {
  const location = useLocation();
  const [page, setPage] = useState("login");

  const isDynamicPage = (pageName: string) => {
    const coinPage = location.pathname.slice(1).split("/");
    switch (coinPage[0]) {
      // Add dynamic pages here e.g /coin/btc => coin
      case "coin":
        seo[pageName] = {
          title: coinPage[1].toUpperCase(),
        };
        break;
      default: {
        return;
      }
    }
  };

  const dynamicTitle = (location: string) => {
    const pageName = location.slice(1);
    isDynamicPage(pageName);

    Object.keys(seo).forEach((key) => {
      if (pageName === key) {
        setPage(key);
      }
    });
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dynamicTitle(location.pathname);
    }
    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>
          {seo[page].title} {defaultTag}
        </title>
      </Helmet>
      {props.children}
    </>
  );
};
